import * as React from 'react';
import cardListIcon from '../../../assets/card-list.svg';

interface CardListIconProps {
    size?: number;
    style?: React.CSSProperties;
}

const CardListIcon: React.FC<CardListIconProps> = ({ size }) => {
    return <img src={cardListIcon} width={size} height={size} />;
};

export default CardListIcon;
